export default __webpack_public_path__ + "static/media/mp4.6dacb2d8.svg";